<ng-template #titleTpl>
  <intelishs-page-header title="Editar Solicitud" [subtitle]="subtitulo()" />
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  [nzFooter]="modalFooter"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    @if (solicitud(); as sol) {
      <div class="modal-detail">
        <div class="detalle-seccion">
          <intelishs-section-header title="Periodo" />
          <nz-range-picker
            style="width: 100%"
            [ngModel]="editDateRange()"
            (ngModelChange)="onEditRangeChange($event)"
            [nzDisabledDate]="disabledDate"
            [nzDateRender]="renderCelda"
            nzFormat="yyyy-MM-dd"
            (keydown.enter)="commitRangeOnEnter(onEditRangeChange, $event)"
          />
          <ng-template #renderCelda let-current>
            <div
              class="ant-picker-cell-inner"
              [class.date-fuera-politica]="esDentroDeDosSemanas(current)"
            >
              {{ current.getDate() }}
            </div>
          </ng-template>
          <div class="form-hint">
            <nz-icon nzType="clock-circle" />
            La política establece al menos 2 semanas de anticipación (desde
            {{ fechaMinimaSolicitud | date: 'dd/MM/yyyy' }}).
          </div>
          @if (editFechaInicioInvalida()) {
            <div class="form-warning">
              <nz-icon nzType="warning" />
              Este rango de fechas no cumple la política de 2 semanas de anticipación. Requiere
              aprobación por Director y RH.
            </div>
          }
        </div>

        <!-- Mismo bloque que el alta: al mover fechas cambia tanto el conteo
             como el ciclo del que salen los días. -->
        @if (editDiasSolicitados() > 0) {
          <div class="resumen">
            <div class="resumen-total">
              <span class="resumen-total-lbl">Días hábiles</span>
              <span class="resumen-total-val">{{ editDiasSolicitados() }}</span>
            </div>

            @if (festivosEnRango().length > 0) {
              <p class="resumen-nota">
                No cuentan {{ textoFestivos() }}:
                {{ festivosEnRangoNombres() }}
              </p>
            }

            @if (distribucionFIFO(); as fifo) {
              <div class="resumen-desglose">
                <span class="resumen-desglose-lbl">Se descuentan de</span>
                @if (fifo.delAnterior > 0) {
                  <div class="resumen-row">
                    <span>Ciclo anterior <em>(vence primero)</em></span>
                    <span class="resumen-row-val"
                      >{{ fifo.delAnterior | number: '1.1-1' }} días</span
                    >
                  </div>
                }
                @if (fifo.delActual > 0) {
                  <div class="resumen-row">
                    <span>Ciclo actual</span>
                    <span class="resumen-row-val">{{ fifo.delActual | number: '1.1-1' }} días</span>
                  </div>
                }
                @if (fifo.negativo > 0) {
                  <div class="resumen-row resumen-row--negativo">
                    <span>Quedas a deber <em>(se compensa con días futuros)</em></span>
                    <span class="resumen-row-val">{{ fifo.negativo | number: '1.1-1' }} días</span>
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Sin `nz-divider` entre secciones: el section-header ya trae su
             propia línea, y las dos juntas parten el modal en franjas. -->
        <div class="detalle-seccion">
          <intelishs-section-header title="Comentarios" />
          <textarea
            nz-input
            rows="2"
            placeholder="Motivo o comentarios..."
            [ngModel]="editComentarios()"
            (ngModelChange)="editComentarios.set($event)"
          ></textarea>
        </div>
      </div>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="sinay-outline-reset" (click)="cerrar()">Cancelar</button>
    <button
      nz-button
      class="btn-add"
      [nzLoading]="editSubmitting()"
      [disabled]="editDiasSolicitados() === 0"
      (click)="submit()"
    >
      Guardar cambios
    </button>
  </ng-template>
</nz-modal>
